import Debug from "debug";

import { ACTIONS } from "./constants";
import {
  ActionChannelGetAll,
  PayloadChannelGetAll,
  PayloadChannelGetOne,
  ActionChannelGetOne,
  PayloadBroadcastSettings,
  ActionBroadcastSettings,
  PayloadChannelDeleteOne,
  ActionChannelDeleteOne,
  PayloadChannelEditOne,
  ActionChannelEditOne,
  PayloadChannelCreateOne,
  ActionChannelCreateOne,
} from "../types";
import { ScreenCloudLogger } from "../ScreenCloudReactApp";

const debug = Debug("broadcast:actions:channels");

export const getChannels = (
  payload: PayloadChannelGetAll,
  logger?: ScreenCloudLogger
): ActionChannelGetAll => {
  debug("getChannels", payload);
  return {
    type: ACTIONS.CHANNELS_GET_ALL_REQUEST,
    payload,
    logger,
  };
};

export const getChannel = (
  payload: PayloadChannelGetOne,
  logger?: ScreenCloudLogger
): ActionChannelGetOne => {
  debug("getChannel", payload);
  return {
    type: ACTIONS.CHANNELS_GET_ONE_REQUEST,
    payload,
    logger,
  };
};

export const getBroadcastSettings = (
  payload: PayloadBroadcastSettings,
  logger?: ScreenCloudLogger
): ActionBroadcastSettings => {
  debug("getBroadcastSettings", payload);
  return {
    type: ACTIONS.BROADCAST_SETTINGS_REQUEST,
    payload,
    logger,
  };
};

export const editChannel = (
  payload: PayloadChannelEditOne,
  logger?: ScreenCloudLogger
): ActionChannelEditOne => {
  debug("editChannel", payload);
  return {
    type: ACTIONS.CHANNELS_EDIT_ONE_REQUEST,
    payload,
    logger,
  };
};

export const deleteChannel = (
  payload: PayloadChannelDeleteOne,
  logger?: ScreenCloudLogger
): ActionChannelDeleteOne => {
  debug("deleteChannel", payload);
  return {
    type: ACTIONS.CHANNELS_DELETE_ONE_REQUEST,
    payload,
    logger,
  };
};

export const createChannel = (
  payload: PayloadChannelCreateOne,
  logger?: ScreenCloudLogger
): ActionChannelCreateOne => {
  debug("createChannel", payload);
  return {
    type: ACTIONS.CHANNELS_CREATE_ONE_REQUEST,
    payload,
    logger,
  };
};

export const renameChannel = (
  payload: PayloadChannelEditOne,
  logger?: ScreenCloudLogger
): ActionChannelEditOne => {
  debug("renameChannel", payload);
  return {
    type: ACTIONS.CHANNELS_EDIT_ONE_REQUEST,
    payload,
    logger,
  };
};
